// src/services/Lookups/WaiverLookupService.ts
export interface WaiverType {
    id: number;
    name: string;
}

export const getWaiverTypes = async (authToken: string): Promise<WaiverType[] | null> => {
    try {
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/lookup/WaiverTypes`;
        const response = await fetch(apiUrl, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            console.error("Failed to fetch waiver types:", response);
            return null;
        }

        const data = await response.json();
        return data as WaiverType[];
    } catch (error) {
        console.error("Error fetching waiver types:", error);
        return null;
    }
};
